import {
  Component,
  ElementRef,
  forwardRef,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  Renderer2,
  ViewChild
} from '@angular/core';
import { FileModel } from '../../typescript-angular-client/model/fileModel';
import { FilesListComponent } from '../files-list/files-list.component';
import { FmTreeService } from '../services/fm-tree.service';

@Component({
  selector: 'file-item',
  templateUrl: './file-item.component.html',
  styleUrls: ['./file-item.component.scss']
})
export class FileItemComponent implements OnDestroy {
  @ViewChild('wrapper', {static: false}) wrapper: ElementRef;
  @ViewChild('image', {static: false}) image: ElementRef;
  @Input() dialogType: FileModel.FileTypeEnum = FileModel.FileTypeEnum.IMAGES;
  @Input() node: FileModel;
  public highligted = false;
  readonly filesDialogType: FileModel.FileTypeEnum = FileModel.FileTypeEnum.DOCUMENTS;
  private fileList: FilesListComponent;
  private _isSingleClick = true;
  private _timer: NodeJS.Timer;

  constructor(
    private fmService: FmTreeService,
    private renderer: Renderer2,
    @Inject(forwardRef(() => FilesListComponent)) fList
  ) {
    this.fileList = fList as FilesListComponent;
  }

  ngOnDestroy(): void {
    this.node = null;
  }

  get isFolder(): boolean {
    return this.node.IsFolder && this.node.IsFolder === true;
  }

  get nodeName(): string {
    return this.node.Name;
  }

  get nodeSrc(): string {
    return this.isFolder ? '' : this.node.Link;
  }

  isSelected = (): boolean => {
    return this.fileList.isSelected(this.node);
  }

  onClick = (event: MouseEvent): void => {
    this._isSingleClick = true;
    this._timer = setTimeout(() => {
      if (!this._isSingleClick) {
        return;
      }
      this.fileList.onElementClick(event, this.node);
    }, 150);
  }

  dblclick = (event: MouseEvent): void => {
    this._isSingleClick = false;
    clearTimeout(this._timer);
    this.fileList.onElementDoubleClick(event, this.node);
  }

  @HostListener('dragstart', ['$event'])
  onDragStart = (event: DragEvent): void => this.fmService.startDrag(this.node);

  onDragStop = (event: DragEvent): void => this.fmService.stopDrag(this.node);

  onDrop = (event: DragEvent): void => {
    event.preventDefault();
    event.stopPropagation();
    if (this.node.IsFolder) {
      this.fileList.itemDropped.emit({
        originalEvent: event,
        draggedItem: this.fileList.draggedItem,
        droppedItem: this.node
      });
      this.highligted = false;
    }
  }

  onDragLeave = (event: DragEvent): void => {
    this.highligted = false;
  }

  onDragEnter = (event: DragEvent): void => {
    if (this.node.IsFolder) {
      this.highligted = true;
    }
  }

  onDragOver = (event: DragEvent): void => {
    event.dataTransfer.dropEffect = 'move';
  }

  onItemRightClick = ($event: MouseEvent): void => {
    this.fileList.onElementRightClick($event, this.node);
  }

  imgLoaded = (flag: boolean): void => {
    if (flag) {
      this.renderer.addClass(this.wrapper.nativeElement, 'img-loaded');
    } else {
      this.renderer.removeClass(this.wrapper.nativeElement, 'img-loaded');
    }
  }

  getImgStyle = (): CSSStyleDeclaration => {
    const originalWidth = (this.node && this.node.Width) ? this.node.Width : 78;
    const originalHeight = (this.node && this.node.Height) ? this.node.Height : 78;
    let newWidth = 0;
    let newHeight = 0;
    const maxWidth = 78;
    const maxHeight = 78;

    if ((originalWidth - maxWidth) > (originalHeight - maxHeight)) {
      newWidth = maxWidth;
      newHeight = Math.round((originalHeight * (maxWidth / originalWidth)));
    } else {
      newHeight = maxHeight;
      newWidth = Math.round((originalWidth * (maxHeight / originalHeight)));
    }

    const style = {} as CSSStyleDeclaration;
    style['max-width'] = '78px';
    style['max-height'] = '78px';
    style.height = `${newHeight}px`;
    style.width = `${newWidth}px`;

    return style;
  }
}
